import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SPLASH_LOGO_SRC,
  SPLASH_MESSAGE_INTERVAL_MS,
  resolveSplashLang,
  splashMessagesForLang,
} from '@/lib/splashMessages';
import './brandedLoading.css';

/**
 * Full-viewport Tagdada splash (matches public/index.html #app-splash).
 * Hides the HTML boot splash on mount for a continuous branded handoff.
 */
export default function BrandedSplash({ message, className = '', 'data-testid': testId = 'branded-splash' }) {
  const { i18n } = useTranslation();
  const lang = i18n?.language || resolveSplashLang();
  const messages = splashMessagesForLang(lang);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    window.__hideAppSplash?.();
  }, []);

  useEffect(() => {
    if (message) return undefined;
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % messages.length);
    }, SPLASH_MESSAGE_INTERVAL_MS);
    return () => clearInterval(id);
  }, [message, messages.length]);

  const text = message || messages[idx % messages.length];

  return (
    <div
      className={`td-branded-splash ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label="Loading Tagdada"
      data-testid={testId}
    >
      <div className="td-branded-splash__ring">
        <img className="td-branded-splash__logo" src={SPLASH_LOGO_SRC} alt="" />
      </div>
      <div className="td-branded-splash__title">Tagdada</div>
      <div className="td-branded-splash__msg">
        <span className="td-branded-splash__txt">{text}</span>
      </div>
    </div>
  );
}
